/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SettleTransactionExternallyRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {SettleTransactionExternallyResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const settleTransactionExternally = (request: SettleTransactionExternallyRequest, options?: CashRequestOptions) => post<SettleTransactionExternallyRequest, SettleTransactionExternallyResponse>("/2.0/cash/settle-transaction-externally", request, {...options, rejectOnError: true })